export enum RuleErrorCodes {
  "RULE_SHIPPING_ROUTE_NOT_FOUND" = "SHIPPING_SERVICE_NOT_AVAILABLE_FOR_ROUTE_OR_NOT_FOUND",
  "BLOCKED_SHIPMENT" = "BLOCKED_SHIPMENT",
  "PUT_INTO_TO_FIX" = "Put into to fix by a rule",
  "WAREHOUSE_NOT_FOUND" = "WAREHOUSE_NOT_FOUND",
  "MULTI_ITEM_DIMENSIONS_NOT_APPLIED" = "Dimensions and weight are only applied automatically for single-item shipments. Please enter the correct package dimensions and weight.",
  "SKU_DIMENSIONS_NOT_FOUND" = "No dimensions and weight are on file for this item SKU. Please enter the correct package dimensions and weight.",
}
